import React from "react";
import { C, BEFORE_AFTER, VALUE_KPIS } from "./data";
import { Eyebrow, KpiRow, cell, colHead } from "./shared";

export function BusinessValueView() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <KpiRow items={VALUE_KPIS} />
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, overflow: "hidden" }}>
        <div style={{ padding: 24, borderBottom: `1px solid ${C.border}` }}><Eyebrow>Before vs. After</Eyebrow></div>
        <div className="np-scroll" style={{ overflowX: "auto" }}>
          <div style={{ minWidth: 760 }}>
            <div style={{ display: "flex", background: C.tableHeadBg, borderBottom: `1px solid ${C.border}`, padding: "12px 24px" }}>
              <span style={{ ...colHead(0), flex: 1 }}>Measure</span><span style={colHead(160)}>Today</span>
              <span style={colHead(200)}>With the Agent</span><span style={colHead(140)}>Delta</span>
            </div>
            {BEFORE_AFTER.map((row) => (
              <div key={row.measure} style={{ display: "flex", alignItems: "center", padding: "16px 24px", borderBottom: `1px solid ${C.border}` }}>
                <span style={{ flex: 1, minWidth: 0, color: C.ink2, fontWeight: 600, fontSize: 13 }}>{row.measure}</span>
                <span style={{ ...cell(160), color: C.muted, fontSize: 13, fontWeight: 500 }}>{row.today}</span>
                <span style={{ ...cell(200), color: C.purple, fontWeight: 600, fontSize: 13 }}>{row.agent}</span>
                <div style={cell(140)}>
                  <span style={{ display: "inline-flex", alignItems: "center", height: 21, padding: "0 10px", borderRadius: 6, background: C.clusterGreenBg, color: C.clusterGreen, fontWeight: 700, fontSize: 11 }}>{row.delta}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
